import { isAndroid, isExist, isWKWebview } from '../helpers/is'
import { get, value } from '../helpers/try'
import config from "../../../config.js"
const root = global || window

const { webview } = root
export const isAkulakuAndroid = () =>
  // isAndroid() && isExist(window.InstallmentObject)
  isAndroid() && isExist(window[config.ANDROID_INTERFACE])
  // isAndroid()
export const isAkulakuIOS = () =>
  // isWKWebview() &&
  // (get(root, 'webkit.messageHandlers.changeLanguage')
  //   |> isExist || get(root, 'webkit.messageHandlers.getAppVersion')
  //   |> isExist)
isWKWebview() && isExist(get(root, 'webkit.messageHandlers.getAppVersionV2'))

export const isAkulaku = () => isAkulakuIOS() || isAkulakuAndroid()

export const isAkulakuBussinessAndroid = () =>
  isAndroid() && isExist(root.webview)
